var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.177 1.6h3.645l.118.187.882 1.413H13.6V4h-.858L12 14.4H4L3.257 4H2.4v-.8h2.78l.88-1.413zM6.12 3.2h3.757l-.5-.8H6.622l-.5.8zM4.06 4l.685 9.6h6.51L11.94 4z"
  })));
};
export default SvgTrash;